// extracted by mini-css-extract-plugin
export var callToAction = "authFlowWrapper-module--callToAction--efcf5";
export var description = "authFlowWrapper-module--description--60187";
export var footer = "authFlowWrapper-module--footer--3d14c";
export var footerContent = "authFlowWrapper-module--footerContent--36be5";
export var heading = "authFlowWrapper-module--heading--a708d";
export var inner = "authFlowWrapper-module--inner--00094";
export var logo = "authFlowWrapper-module--logo--d2c3b";
export var wrapper = "authFlowWrapper-module--wrapper--480b8";